import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  request: {
    isLoading: boolean;
    error: string | null;
  };
  one: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
  list: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
  stats: Record<string, any>;
}

const initialState: InitialStateProps = {
  request: {
    isLoading: false,
    error: null,
  },
  one: {
    isLoading: false,
    data: null,
    error: null,
  },
  list: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
  stats: {},
};

export const { actions: applicationActions, reducer: applicationReducer } = createSlice({
  name: 'application',
  initialState,
  reducers: {
    //Request
    setApplicationRequestStart: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setApplicationRequestSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setApplicationRequestFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setApplicationRequestDefault: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    //List
    setApplicationListRequest: (state) => {
      state.list = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setApplicationListSuccess: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setApplicationListFailure: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setApplicationListDefault: (state) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
    //One
    setApplicationOneRequest: (state) => {
      state.one = {
        isLoading: true,
        data: null,
        error: null,
      };
    },
    setApplicationOneSuccess: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setApplicationOneFailure: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setApplicationOneDefault: (state) => {
      state.one = {
        isLoading: false,
        data: null,
        error: null,
      };
    },

    setApplicationStatsRequest: (state) => {
      state.stats = {
        isLoading: true,
        data: null,
        error: null,
      };
    },
    setApplicationStatsSuccess: (state, { payload }) => {
      state.stats = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setApplicationStatsFailure: (state, { payload }) => {
      state.stats = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
  },
});
